import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { ForgetPasswordComponent } from '../components/forget-password/forget-password.component';
import { OtpGenerationComponent } from '../components/otp-generation/otp-generation.component';
import { InvalidPathComponent } from '../components/invalid-path/invalid-path.component';
import { ServerDownComponent } from '../components/server-down/server-down.component';

const routes: Routes = [{
  path: '',
  component: LoginComponent
}, {
  path: 'forget-password',
  component: ForgetPasswordComponent
}, {
  path: 'verify-otp',
  component: OtpGenerationComponent
}, {
  path: 'invalid-page',
  component: InvalidPathComponent
}
// , {
//   path: 'server-unavailable',
//   component: ServerDownComponent
// }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
